export default __webpack_public_path__ + "static/09-f744c265ba68ad46377fe54706c04674.png";